// Main JS
import lity from 'lity';

(function ($) {

    $(document).ready(() => { 

        //
        // general
        //

        // Menu
        let bIsMenuOpen = false;
        $('#toggle-menu').on('click', () => {
            bIsMenuOpen = !bIsMenuOpen;

            console.log('menu toggle', bIsMenuOpen);
            if (bIsMenuOpen) {
                $('ul.menu').addClass('opened');
                $('#toggle-menu').addClass('opened');
            }
            else {
                $('ul.menu').removeClass('opened');
                $('#toggle-menu').removeClass('opened');
            }
        })

        //
        // TEAM
        //
        if ($('div.team').length > 0) {
            // switch team member
            $('.team .list ul li').on('click', function () {
                $('.list ul li, .presentation, .images').removeClass('selected');

                $('#description-' + $(this).attr('id') + ', #gallery-' + $(this).attr('id'))
                    .addClass('selected');

                $(this).addClass('selected');
            })
        }

        //
        // Jobs
        //
        if ($('.jobs').length > 0) {

            const car_previous = (e) => {
                if (e.currentTarget.classList.contains('start')) {
                    $('.caroussel')[0].scrollTo({
                        left: $('.caroussel')[0].scrollWidth,
                        behavior: 'smooth'
                    });                    
                }
                else {
                    console.log('PREV NORMAL')
                    $('.caroussel')[0].scrollTo({
                        left: $('.caroussel')[0].scrollLeft -= document.body.clientWidth,
                        behavior: 'smooth'
                    });
                }
            }

            const car_next = (e) => {
                if (e.currentTarget.classList.contains('end')) {
                    $('.caroussel')[0].scrollTo({
                        left: 0,
                        behavior: 'smooth'
                    });
                }
                else {
                    $('.caroussel')[0].scrollTo({
                        left: $('.caroussel')[0].scrollLeft += document.body.clientWidth,
                        behavior: 'smooth'
                    });
                }
            }

            $('#prev-next #prev').on('click', car_previous);
            $('#prev-next #next').on('click', car_next);
        }

        //
        // WORKS
        //
        if ($('div.works').length > 0) {

            var domains = [];
            var markets = [];

            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            
            let domainsInUrl = urlParams.get('domain') ?? '';
            let marketsInUrl = urlParams.get('market') ?? '';

            domains = domainsInUrl.split(',');
            markets = marketsInUrl.split(',');

            function checkSelected() {
                domains = [];
                $('#domains ul li').each(function () {
                    if ($(this).hasClass('selected')) {
                        domains.push($(this).data('choice'));
                    }
                })
                markets = []
                $('#markets ul li').each(function () {
                    if ($(this).hasClass('selected')) {
                        markets.push($(this).data('choice'));
                    }
                })

                if (domains.length > 0) {
                    console.log("yo domains", markets.length);
                    $('.domains-filter .info').show();
                    $('.domains-filter .info').text(domains.length);
                }
                else {
                    $('.domains-filter .info').hide();
                }
                if (markets.length > 0) {
                    console.log("yo markets", markets.length);
                    $('.markets-filter .info').show();
                    $('.markets-filter .info').text(markets.length);
                }
                else {
                    $('.markets-filter .info').hide();
                }
            }

            $('button#cancel').on('click', function () {
                $('.filter-holder').removeClass('opened');

                checkSelected();
            })

            $('button#apply-filters').on('click', function () {
                const myUrlWithParams = new URL(window.location.origin + window.location.pathname);

                const domainFilter = domains.join();
                const marketFilter = markets.join();

                myUrlWithParams.searchParams.append("market", marketFilter);
                myUrlWithParams.searchParams.append("domain", domainFilter);
                window.location.href = myUrlWithParams;
            })

            $('.filter .filter-title').on('click', function () {
                $(this).parent().children('.filter-holder').toggleClass('opened');

                checkSelected();
            })

            checkSelected();

            $('#domains ul li').on('click', function () {
                if (domains.includes($(this).data('choice'))) {
                    $(this).removeClass('selected');
                }
                else {
                    $(this).addClass('selected');
                }

                checkSelected()
            })

            $('#markets ul li').on('click', function () {
                if (markets.includes($(this).data('choice'))) {
                    $(this).removeClass('selected');
                }
                else {
                    $(this).addClass('selected');
                }

                checkSelected()
            })
        }
    })

})(jQuery); 
